import { render, staticRenderFns } from "./CategoryAddEdit.vue?vue&type=template&id=4abc4677&scoped=true"
import script from "./CategoryAddEdit.vue?vue&type=script&lang=js"
export * from "./CategoryAddEdit.vue?vue&type=script&lang=js"
import style0 from "./CategoryAddEdit.vue?vue&type=style&index=0&id=4abc4677&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abc4677",
  null
  
)

export default component.exports